import urlConfig, { UrlConfig, SingleUrlConfig } from '@root/url.config';

export enum SERVER_ENV_ENUM {
  local = 'local',
  preview = 'preview',
  dev = 'dev',
  uat = 'uat',
  int = 'int',
  prd = 'prd',
}

// @ts-expect-error NEXT_PUBLIC_SERVER_ENV is a free string, not a SERVER_ENV_ENUM key
const SERVER_ENV: SERVER_ENV_ENUM = SERVER_ENV_ENUM[process.env.NEXT_PUBLIC_SERVER_ENV] || SERVER_ENV_ENUM.local;

interface Environment {
  name: string;
  devTools: boolean;
}

interface Config extends Environment {
  environment: SERVER_ENV_ENUM;
  url: SingleUrlConfig;
  features: {
    websocket: boolean;
  };
}

const environment: Environment = {
  local: {
    name: 'local',
    devTools: false,
  },
  preview: {
    name: 'preview',
    devTools: false,
  },
  dev: {
    name: 'dev',
    devTools: false,
  },
  uat: {
    name: 'uat',
    devTools: false,
  },
  int: {
    name: 'int',
    devTools: false,
  },
  prd: {
    name: 'prd',
    devTools: false,
  },
}[SERVER_ENV];

console.log('================== ENV CONFIG ==================');
console.log(` SERVER_ENV : ${SERVER_ENV}`);
console.log('environment :', environment);
console.log('================================================');

const config: Config = {
  environment: SERVER_ENV,

  features: {
    websocket: process.env.NEXT_PUBLIC_WEBSOCKET_ENABLED !== 'false', // Default to enabled
  },

  url: (urlConfig as UrlConfig)[SERVER_ENV],

  ...environment,
};

export default config;
